<div class="wrapper" #wrapper>
  <div
    class="avatar"
    [ngClass]="size()"
    (click)="avatarClicked.emit(wrapper)"
    (keydown)="onAvatarKeyDown($event, wrapper)">
    {{ name() }}
  </div>
</div>
